import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Skeleton from '@material-ui/lab/Skeleton'

const ListSkeleton = () => {
  const theme = useTheme()
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('xs'))
  const isMediumDevice = useMediaQuery(theme.breakpoints.down('sm'))

  let columnKeys = [1, 2, 3, 4, 5]

  if (isSmallDevice) {
    columnKeys = [1]
  } else if (isMediumDevice) {
    columnKeys = [1, 2, 3]
  }

  return <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          {columnKeys.map((_, i) => (
            <TableCell key={i}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {columnKeys.map((_, i) => (
            <TableCell key={i} style={{ borderBottom: 'none' }}>
              <Skeleton />
              <Skeleton style={{ margin: '8px 0' }} />
              <Skeleton />
              <Skeleton style={{ margin: '8px 0' }} />
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
}

export default ListSkeleton
